// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3Gyrb","requiredAsterisk":"Info_requiredAsterisk__Nxuis"};